<template>
    <div id="coursePackageList">
        <img
            v-if="pushCoursePackageList.length !== 0"
            @click="onShowPackageList"
            class="shopping-cart-icon"
            src="@/images/shopping-cart-icon.png"
        />
        <div class="package-list" v-if="isShowPackageList && pushCoursePackageList.length !== 0">
            <div class="title">
                <span>共{{ pushCoursePackageList.length }}件商品</span>
                <van-icon @click="isShowPackageList = false" name="cross" />
            </div>
            <div class="list">
                <div class="item" v-for="item in pushCoursePackageList" :key="item.id">
                    <img :src="item.liveSellImage" />
                    <div>
                        <div class="package-title">{{ item.title }}</div>
                        <div>
                            <div>
                                <span class="package-price">¥{{ item.price / 100 }}</span>
                                <span class="original-price">¥{{ item.originalPrice / 100 }}</span>
                            </div>
                            <span class="buy-btn-disabled" key="btn" v-if="!item.onSale">已下架</span>
                            <span class="buy-btn" @click="onActivePackage(item, 'Click')" key="btn" v-else>抢 购</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="payment-dialog" v-if="activePackage">
            <div class="payment-content">
                <van-icon class="close-icon" @click="onClosePaymentDialog" name="cross" />
                <div class="title">直播特惠</div>
                <div class="goods-info">
                    <div>
                        <img class="cover" :src="activePackage.liveSellImage" />
                        <div class="course-name">{{ activePackage.title }}</div>
                        <div class="price">
                            <span>¥{{ activePackage.price / 100 }}</span>
                            <span class="original-price">¥{{ activePackage.originalPrice / 100 }}</span>
                        </div>
                    </div>
                    <div class="payment-container" v-show="activePackage.onSale">
                        <div v-show="!isShowWxQrcode">
                            <div class="subtitle">请填写报名信息</div>
                            <div class="user-item">
                                <span class="label" v-html="'姓&emsp;&emsp;名'"></span>
                                <input v-model="userName" placeholder="请填写真实姓名" />
                            </div>
                            <div class="user-item">
                                <span class="label" v-html="'手&ensp;机&ensp;号'"></span>
                                <input v-model="userTel" placeholder="请填写有效的手机号" />
                            </div>
                            <div class="user-item">
                                <span class="label">支付方式</span>
                                <van-radio-group v-model="activePayType" direction="horizontal">
                                    <van-radio
                                        icon-size="14px"
                                        v-for="item in payTypeList"
                                        :key="item"
                                        :name="item"
                                        checked-color="#07c160"
                                    >
                                        <span v-if="item === 'wxpay'">微信支付</span>
                                        <span v-if="item === 'alipay'">支付宝付款</span>
                                    </van-radio>
                                </van-radio-group>
                            </div>
                            <div class="submit-btn" @click="onSubmit">提交订单</div>
                            <div class="user-agm" v-if="activePackage.sellExtra && activePackage.sellExtra.agreementId">
                                <van-checkbox icon-size="14px" checked-color="#07c160" v-model="agmChecked">
                                    <span>我已阅读并同意</span>
                                    <span class="agm-btn" @click.stop="onOpenConfirmAgreementPc">
                                        《网络培训服务协议》
                                    </span>
                                </van-checkbox>
                            </div>
                        </div>
                        <div class="wx-qrcode-container" v-show="isShowWxQrcode">
                            <canvas class="wx-qrcode" ref="canvas"></canvas>
                            <div class="desc">二维码30分钟有效，使用微信扫码支付</div>
                            <div class="btns">
                                <div class="btn" @click="isShowWxQrcode = false">取消</div>
                                <div class="btn query-btn" @click="onQueryPayStatus">我已支付</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ConfirmAgreementPc
            :isShow="isShowConfirmAgreementPc"
            @onClose="isShowConfirmAgreementPc = false"
            :url="agreementUrl"
        />

        <div class="product-dialog" v-if="isShowProductDialog">
            <div class="payment-content" v-if="productInfo">
                <van-icon class="close-icon" @click="onCloseProductDialog" name="cross" />
                <div class="title">直播特惠</div>
                <img class="cover" :src="productInfo.liveSellImage" />
                <div class="course-name">{{ productInfo.title }}</div>
                <div class="price" v-if="productInfo.onSale">
                    <span>¥{{ productInfo.price / 100 }}</span>
                    <span class="original-price">¥{{ productInfo.originalPrice / 100 }}</span>
                </div>
                <div class="buy-btn" @click="onPayment">立即抢购</div>
            </div>
        </div>
        <OrderDialog ref="orderDialog" />
    </div>
</template>
<script>
import OrderDialog from '@/components/orderVerify/Dialog'
import { getCourseInfo, liveCoursePackage, getPayType, fetchOrder, shortText, getPaidStatus } from '@/utils/api.js'
import { getTradeStatus } from '@/utils/api.js'
import ConfirmAgreementPc from '@/components/ConfirmAgreementPc'
import { getUserNameTel, setUserNameTel, urlQuery } from '@/utils/utils.js'
import { getUserInfo } from '@/utils/login.js'
const QRCode = require('qrcode')

export default {
    components: { ConfirmAgreementPc, OrderDialog },
    props: ['pushProductList', 'courseNo', 'liveId'],
    watch: {
        pushProductList: function () {
            this.updateCoursePackageList()
        },
        courseNo: function () {
            this.liveCoursePackageApi()
            this.getPayTypeApi()
        },
    },
    data() {
        return {
            activePayType: 'wxpay',
            userName: '',
            userTel: '',
            payTypeList: [],

            isShowConfirmAgreementPc: false,
            agreementUrl: '',
            agmChecked: false,

            isShowWxQrcode: false,
            isShowPackageList: false,
            activePackage: null,
            pushCoursePackageList: [],

            productInfo: null,
            isShowProductDialog: false,
        }
    },
    created() {
        // 默认查询一次已购买课程
        this.userProductAliasIds = []
        this.getTradeStatusApi()

        const data = getUserNameTel()
        this.userName = data.userName
        this.userTel = data.userTel
    },
    methods: {
        // 新支付流程
        onShowProductDialog(item) {
            this.productInfo = item
            this.isShowProductDialog = true
        },
        onCloseProductDialog() {
            this.productInfo = null
            this.isShowProductDialog = false
        },
        onPayment() {
            const _options = urlQuery()
            const _userInfo = getUserInfo()
            this.$refs.orderDialog.onShow({
                productInfo: {
                    onSale: this.productInfo.onSale,
                    productNo: this.productInfo.packageNo,
                    productType: 1,
                },
                userInfo: _userInfo,
                liveId: this.liveId,
                sn: _options.sn,
            })
            this.$nextTick(() => {
                this.onCloseProductDialog()
            })
        },

        onShowPackageList() {
            this.liveCoursePackageApi()
            this.isShowPackageList = true
        },
        onShowPackage(item) {
            // 根据 url/推送参数  区分支付弹窗
            const _options = urlQuery()
            if (_options.agmVersion === 'old') {
              this.activePackage = item
              this.isShowWxQrcode = false
              this.agmChecked = false
            } else {
              // 已显示弹窗/正在支付中 不做其他操作
              if (!this.isShowProductDialog) {
                this.onShowProductDialog(item)
              }
            }
        },
        onActivePackage(item, action) {
            if (!this.activePackage) {
                if (action === 'Click') {
                    this.onShowPackage(item)
                } else if (action === 'Push') {
                    console.log('推送商品', item)
                    const _aliasId = item.sellExtra ? item.sellExtra.aliasId : ''
                    // 推送弹窗查看当前商品是否 已购买
                    if (!this.userProductAliasIds.includes(parseInt(_aliasId))) {
                        this.onShowPackage(item)
                    }
                }
            }
        },
        onClosePaymentDialog() {
            this.activePackage = null
        },
        onQueryPayStatus() {
            const userInfo = getUserInfo()
            getPaidStatus({ packageNo: this.activePackage.packageNo, userId: userInfo.id }).then((res) => {
                if (res.data && res.data.status) {
                    this.$toast.success('支付成功')
                    this.onClosePaymentDialog()
                } else {
                    this.$toast.fail('支付未完成')
                }
            })
        },
        onSubmit() {
            const { userName, userTel, activePackage, agmChecked, activePayType, liveId } = this
            const userInfo = getUserInfo()

            if (!userName || !userTel) {
                return this.$toast('请填写完整信息')
            } else if (!new RegExp(/^1[0-9]{10}$/).test(this.userTel)) {
                return this.$toast('手机号格式错误')
            }

            if (!agmChecked) {
                this.$dialog
                    .confirm({
                        className: 'confirm-dialog',
                        title: '友情提示',
                        message: `我已阅读并同意<span id="confirmDialogAgm">《网络培训服务协议》</span>`,
                        confirmButtonText: '同意并继续',
                        confirmButtonColor: '#44cd94',
                    })
                    .then(() => {
                        this.agmChecked = true
                        this.onSubmit()
                        document.onclick = null
                    })
                    .catch(() => {
                        document.onclick = null
                    })

                document.onclick = (event) => {
                    if (event.target.id === 'confirmDialogAgm') {
                        this.onOpenConfirmAgreementPc()
                    }
                }
                return
            }

            let payFee = activePackage.price
            const params = {
                appId: window.ALI_APPID,
                userId: userInfo.id,
                productType: 1,
                agreementStatus: false,
                packageNo: activePackage.packageNo,
                productNo: activePackage.packageNo,
                orderDetail: {
                    tradeType: 'pc_pay',
                    tradeProvider: activePayType,
                    payFeeType: 1,
                    payFee: payFee,
                },
                sourceFrom: liveId,
                sourceType: 1,
                userContact: {
                    userId: userInfo.id,
                    name: userName,
                    telNo: userTel,
                },
            }
            if (activePayType === 'wxpay') {
                params.appId = window.WX_APPID
                params.orderDetail.tradeType = 'NATIVE'
            } else if (activePayType === 'alipay') {
                params.appId = window.ALI_APPID
                params.orderDetail.tradeType = 'pc_pay'
            }

            if (activePackage.sellExtra && activePackage.sellExtra.agreementId) {
                params.agreementStatus = true
            }

            fetchOrder(params).then((res) => {
                setUserNameTel({ userName, userTel })
                if (activePayType === 'wxpay') {
                    this.isShowWxQrcode = true
                    QRCode.toCanvas(
                        this.$refs.canvas,
                        res.data.codeUrl,
                        { width: 228, height: 228, margin: 2, errorCorrectionLevel: 'L' },
                        (err) => {
                            if (err) this.$toast('生成支付二维码失败，请稍后再试')
                        }
                    )
                } else if (activePayType === 'alipay') {
                    shortText(res.data.payShortKey).then((short) => {
                        if (short.data) {
                            this.$toast({
                                className: 'success-toast',
                                message: '已打开支付宝付款地址，请前往支付',
                            })
                            window.open(short.data, '_blank')
                        } else {
                            this.$toast('创建订单失败')
                        }
                    })
                }
            })
        },
        onOpenConfirmAgreementPc() {
            this.agreementUrl = `./agm.html?agmId=${this.activePackage.sellExtra.agreementId}`
            this.isShowConfirmAgreementPc = true
        },
        updateCoursePackageList() {
            const currentProduct = this.pushProductList[0]
            // pop：新增 remove：撤销 unsale：下架
            if (currentProduct.type === 'pop') {
                const timeNum = Math.floor(Math.random() * 2000)
                let status = true
                for (let index = 0; index < this.pushCoursePackageList.length; index++) {
                    const item = this.pushCoursePackageList[index]
                    if (item.packageNo === currentProduct.productNo) {
                        this.onActivePackage(item, 'Push')
                        status = false
                        break
                    }
                }
                if (status) {
                    setTimeout(() => {
                        this.getCourseInfoApi(currentProduct.productNo, false)
                    }, timeNum || 1000)
                }
            } else if (currentProduct.type === 'rollback') {
                for (let index = 0; index < this.pushCoursePackageList.length; index++) {
                    const item = this.pushCoursePackageList[index]
                    if (item.packageNo === currentProduct.productNo) {
                        this.pushCoursePackageList.splice(index, 1)
                        if (this.activePackage && currentProduct.productNo === this.activePackage.packageNo) {
                            this.onClosePaymentDialog()
                        }
                        break
                    }
                }
            } else if (currentProduct.type === 'refresh') {
                for (let index = 0; index < this.pushCoursePackageList.length; index++) {
                    const item = this.pushCoursePackageList[index]
                    if (item.packageNo === currentProduct.productNo) {
                        this.getCourseInfoApi(currentProduct.productNo, true)
                        break
                    }
                }
            }
        },
        getCourseInfoApi(courseNo, isUpdate) {
            getCourseInfo(courseNo).then((res) => {
                if (res.data) {
                    if (isUpdate) {
                        for (let index = 0; index < this.pushCoursePackageList.length; index++) {
                            const item = this.pushCoursePackageList[index]
                            if (item.packageNo === courseNo) {
                                this.pushCoursePackageList[index] = res.data
                                break
                            }
                        }
                        this.onClosePaymentDialog()
                        this.$forceUpdate()
                    } else {
                        this.pushCoursePackageList.push(res.data)
                        this.onActivePackage(res.data, 'Push')
                    }
                }
            })
        },
        getPayTypeApi() {
            getPayType().then((res) => {
                if (res.data) {
                    this.payTypeList = res.data.split(',')
                    this.activePayType = this.payTypeList[0]
                }
            })
        },
        liveCoursePackageApi() {
            liveCoursePackage({ courseNo: this.courseNo }).then((res) => {
                if (res.data && res.data.length !== 0) {
                    this.pushCoursePackageList = res.data
                }
            })
        },
        getTradeStatusApi() {
            const userInfo = getUserInfo()
            if (userInfo) {
                getTradeStatus({ aliasFlag: true, userId: userInfo.id }).then((res) => {
                    this.userProductAliasIds = res.data.aliasIds || []
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
#coursePackageList {
    .shopping-cart-icon {
        position: fixed;
        bottom: 180px;
        right: 20px;
        width: 40px;
        height: 40px;
        cursor: pointer;
    }
    .package-list {
        position: fixed;
        bottom: 0;
        right: 0;
        width: 282px;
        padding-bottom: 40px;
        max-height: 300px;
        min-height: 120px;
        z-index: 100;
        background: #eaeaea;
        .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 36px;
            padding: 0 20px;
            font-size: 15px;
            .van-icon {
                cursor: pointer;
                font-size: 20px;
            }
        }
        .list {
            overflow-x: hidden;
            overflow-y: scroll;
            height: 204px;
            .item {
                padding: 6px 12px;
                margin-bottom: 6px;
                display: flex;
                // background: #fff;
                justify-content: space-between;
                img {
                    width: 108px;
                    height: 72px;
                    border-radius: 4px;
                }
                > div {
                    flex-grow: 1;
                    margin-left: 12px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    > div {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 3px;
                        font-size: 13px;
                        align-items: center;
                        font-weight: 700;
                    }
                }
                .package-title {
                    font-size: 14px;
                    font-weight: 700;
                    color: #333;
                    line-height: 1.4em;
                }
                .package-price {
                    font-size: 13px;
                    color: #f00;
                }
                .original-price {
                    color: #999;
                    font-size: 12px;
                    margin-left: 4px;
                    font-weight: 400;
                    display: inline-block;
                    transform: scale(0.9);
                    text-decoration: line-through;
                }
                .buy-btn-disabled,
                .buy-btn {
                    background: #f00;
                    padding: 4px 8px;
                    border-radius: 10px;
                    color: #fff;
                    cursor: pointer;
                    flex-shrink: 0;
                }
                .buy-btn-disabled {
                    background: #e1e1e1;
                    color: #999;
                    padding: 4px 10px;
                    font-size: 12px;
                }
            }
        }
    }
    .payment-dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #333, $alpha: 0.4);
        z-index: 999;
        display: flex;
        justify-content: center;
        align-items: center;
        .payment-content {
            background: #fff;
            width: 560px;
            height: 368px;
            border-radius: 10px;
            box-shadow: 0 10px 15px rgba($color: #666, $alpha: 0.4);
            position: relative;
            .close-icon {
                font-size: 24px;
                position: absolute;
                top: 18px;
                right: 18px;
                cursor: pointer;
            }
            .title {
                padding-top: 12px;
                line-height: 40px;
                font-size: 22px;
                text-align: center;
            }
            .goods-info {
                display: flex;
                justify-content: space-between;
                // padding-left: 10px;
                > div {
                    padding: 20px 20px 0;
                }
                .cover {
                    width: 240px;
                    height: 160px;
                    border-radius: 4px;
                    object-fit: cover;
                }
                .course-name {
                    line-height: 24px;
                    height: 48px;
                    font-size: 16px;
                    overflow: hidden;
                    width: 240px;
                    margin-top: 20px;
                }
                .price {
                    font-size: 24px;
                    color: #f34747;
                    line-height: 30px;
                    font-weight: 600;
                }
                .original-price {
                    color: #999;
                    font-size: 16px;
                    margin-left: 10px;
                    font-weight: 400;
                    text-decoration: line-through;
                }
                .describe {
                    font-size: 16px;
                    text-align: center;
                    width: 200px;
                    text-align: center;
                }
                .payment-qrcode {
                    width: 200px !important;
                    height: 200px !important;
                    margin: 0 auto;
                    display: block;
                }
                .other-describe {
                    font-size: 14px;
                    color: #999;
                    width: 200px;
                    text-align: center;
                    line-height: 16px;
                }
            }
        }
    }
    .payment-container {
        padding: 5px 10px !important;
        width: 280px;
        .subtitle {
            font-size: 14px;
            color: #666;
        }
        .user-item {
            display: flex;
            align-items: center;
            margin-top: 20px;
            .label {
                height: 40px;
                line-height: 40px;
                width: 60px;
                text-align: right;
                color: #666;
                padding-right: 10px;
                font-size: 14px;
                display: flex;
                justify-content: space-between;
            }
            input {
                height: 36px;
                line-height: 36px;
                font-size: 13px;
                width: 160px;
                border: 1px solid #ccc;
                border-radius: 4px;
                padding-left: 12px;
                box-sizing: border-box;
            }
            :deep(.van-radio-group) {
                font-size: 13px;
            }
        }
        .submit-btn {
            width: 180px;
            line-height: 32px;
            height: 32px;
            margin: 20px 0 0 36px;
            text-align: center;
            font-size: 14px;
            border-radius: 4px;
            background: #44cd94;
            color: #fff;
            cursor: pointer;
        }
        .user-agm {
            margin: 12px 0 0 0;
            .agm-btn {
                color: #44cd94;
            }
            :deep(.van-checkbox__label) {
                font-size: 13px;
                color: #333;
                opacity: 0.8;
            }
            :deep(.van-checkbox__icon--checked) {
                .van-icon {
                    color: #07c160;
                    background: none !important;
                    border-color: #07c160;
                }
            }
        }
        .wx-qrcode-container {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .wx-qrcode {
            width: 228px;
            height: 228px;
        }
        .desc {
            font-size: 13px;
            text-align: center;
            color: #666;
        }
        .btns {
            display: flex;
            justify-content: space-evenly;
            margin-top: 20px;
            width: 100%;
        }
        .btn {
            width: 80px;
            height: 32px;
            background: #bbb;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 14px;
            border-radius: 4px;
        }
        .query-btn {
            background: #07c160;
        }
    }
    .product-dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #333, $alpha: 0.4);
        z-index: 999;
        display: flex;
        justify-content: center;
        align-items: center;
        .payment-content {
            background: #fff;
            width: 360px;
            border-radius: 5px;
            border: 1px solid rgba(151, 151, 151, 1);
            position: relative;
            padding: 0 28px;
            .close-icon {
                font-size: 28px;
                position: absolute;
                top: 16px;
                right: 16px;
                cursor: pointer;
                color: #c9c6c6;
            }
            .title {
                line-height: 64px;
                font-size: 20px;
                text-align: center;
                color: #4a4a4a;
            }
            .cover {
                width: 100%;
                border-radius: 4px;
                display: block;
                margin: 0 auto;
            }
            .course-name {
                font-size: 17px;
                line-height: 24px;
                color: #6a696a;
                margin: 16px auto;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .price {
                font-size: 30px;
                color: #f34747;
                line-height: 32px;
                font-weight: 600;
                color: rgba(255, 56, 6, 1);
            }
            .original-price {
                color: #c9c6c6;
                font-size: 16px;
                margin-left: 10px;
                font-weight: 400;
                text-decoration: line-through;
            }
            .buy-btn {
                background: linear-gradient(45deg, #ff0000, #ff5700);
                width: 240px;
                margin: 32px auto 42px;
                height: 42px;
                line-height: 42px;
                font-size: 21px;
                border-radius: 4px;
                font-weight: 400;
                text-align: center;
                color: #fff;
                cursor: pointer;
                &.unsale-btn {
                    color: #999;
                    background: #f4f4f5;
                    font-size: 18px;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.confirm-dialog {
    #confirmDialogAgm {
        cursor: pointer;
        color: #44cd94;
    }
}
</style>
